module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS5.cc7819cc.jpg";